import React, { useEffect } from 'react';
import Separator from "../Separator";

const InnerPage = ({ children, className = '', scrollTop, background }) => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [scrollTop]);

  return (
    <>
      <div className={`section page ${className}`}>
        {background && (
          <img
            style={{
              transition: "opacity ease-in-out 0.5s",
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%'
            }}
            src={background}
            alt={'background'}
          />
        )}
        {children}
      </div>
      <div className="section">
        <Separator />
      </div>
    </>
  );
};

export default InnerPage;